import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import Image from "../../../../shared/components/Image";
import { fcbId } from "./Index";

function arabicMatchday(num) {
    const ordinals = {
        1: "الأولى",
        2: "الثانية",
        3: "الثالثة",
        4: "الرابعة",
        5: "الخامسة",
        6: "السادسة",
        7: "السابعة",
        8: "الثامنة",
        9: "التاسعة",
        10: "العاشرة",
        11: "الحادية عشرة",
        12: "الثانية عشرة"
    };

    // For 1–12 use ordinal, for 13+ use plain number
    return `${ordinals[num] || num}`;
}

const StandingLabel = ({ played, selectedLang }) => {
    const { t } = useTranslation();
    const isAR = selectedLang === "ar";
    return (
        <div className={`${isAR ? "table-head-ar" : "table-head"}`}>
            <div className={"col-pos col"}>{t("Matchday", { lng: selectedLang })} {isAR ? arabicMatchday(played) : played}</div>
            <div className={"col-team col"}></div>
            <div className={"col-points col"}>{t("PL", { keyPrefix: "table", lng: selectedLang })}</div>
            <div className={"col-pkt col"}>{t("PTS", { keyPrefix: "table", lng: selectedLang })}</div>
            <div className={"col-diff col"}>{t("GD", { keyPrefix: "table", lng: selectedLang })}</div>
        </div>
    );
};

export const UEFAStandingContent = ({
    played,
    content,
    className,
    startingIndex,
    linesMarkersByRankType,
    competitionId,
    selectedLang
}) => {
    const { t } = useTranslation();
    const redMarkIndex = _.find(linesMarkersByRankType, {
        relegation: true,
    })?.rowIndex;
    const greenMarkIndex = _.findLast(linesMarkersByRankType, {
        relegation: false,
    })?.rowIndex;
    const rowGradientBegin = greenMarkIndex;
    const rowGradientEnd = redMarkIndex;
    const firstRankStatus = linesMarkersByRankType[0]?.rankStatus;
    const secondRankStatus = linesMarkersByRankType[1]?.rankStatus;
    const isAR = selectedLang === "ar";
    return (
        <div className={`${isAR ? "uefa-group-table table-ar" : "uefa-group-table"}`}>
            <div className={"uefa-group-content"}>
                <StandingLabel played={played} selectedLang={selectedLang} />
                <div className={`uefa-rankstatus ${isAR ? "rankstatus-ar" : ""}`}>
                    {t("Round of 16", { keyPrefix: "table", lng: selectedLang })}
                </div>
                <div className={`uefa-rankstatus second ${isAR ? "rankstatus-ar" : ""}`}>
                    {t("Knockout round", { keyPrefix: "table", lng: selectedLang })}
                </div>
                <div className={`uefa-rankstatus third ${isAR ? "rankstatus-ar" : ""}`}>
                    {t("Elimination", { keyPrefix: "table", lng: selectedLang })}
                </div>
                {content.map((entry, index) => {
                    const properIndex = index + startingIndex;
                    const markRowIndex = _.findIndex(linesMarkersByRankType, {
                        rowIndex: properIndex + 1,
                    });
                    const isFCB = entry.contestantId === fcbId;

                    const isMarked = markRowIndex > -1;
                    //we need to simulate border top here
                    const redMark = properIndex + 2 === redMarkIndex;

                    const bottomRedMark = linesMarkersByRankType?.[markRowIndex]?.redLine;
                    return (
                        <div
                            key={"uefa-table-" + index}
                            className={`uefa-table-row ${isFCB ? "table-fcb" : ""} ${isMarked ? "mark-row" : ""} ${isAR ? "table-row-ar" : ""} ${redMark || bottomRedMark ? "red-mark-row" : ""} ${rowGradientBegin > properIndex || rowGradientEnd <= properIndex + 1 ? "mark-row-gradient" : ""} ${className}`}
                        >
                            <div className={"col-pos col"}>{++index + startingIndex}</div>
                            <div className={"col-team col"}>
                                <div className={"col-logo"}>
                                    <Image
                                        className="team-logo"
                                        src={getDynamicLogoPath({
                                            team: {
                                                id: entry?.contestantId,
                                                code: entry?.contestantCode,
                                                name: entry?.contestantName,
                                                shortName: entry?.contestantShortName,
                                            },
                                            competitionId,
                                        })}
                                    />
                                </div>
                                {t(entry?.contestantName || entry?.contestantShortName, {
                                    ns: "countries", lng: selectedLang
                                }) || entry?.contestantName}
                            </div>
                            <div className={"col-points col"}>{entry.matchesPlayed}</div>
                            <div className={"col-pkt col"}>{entry.points}</div>
                            <div className={"col-diff col"}>{entry.goaldifference}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};